import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import InventoryIcon from "@mui/icons-material/Inventory";
import LanguageIcon from "@mui/icons-material/Language";
import SettingsIcon from "@mui/icons-material/Settings";
import { itemTypes } from "./types/itemTypes";

export const sectionsList: itemTypes[] = [
  { id: "V", type: "analitics", Icon: QueryStatsIcon },
  { id: "A", type: "purchases", Icon: AssignmentReturnedIcon, peopleId: "pro" },
  { id: "B", type: "sales", Icon: PointOfSaleIcon, peopleId: "cli" },
  { id: "C", type: "services", Icon: DesignServicesIcon, peopleId: "cli" },
  { id: "F", type: "items", Icon: InventoryIcon },
  { id: "G", type: "web", Icon: LanguageIcon },
  { id: "D", type: "admin", Icon: AccountTreeIcon },
  { id: "Z", type: "settings", Icon: SettingsIcon },
];
